import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const STORAGE_KEY = "mailflow_theme_mode"; // 'auto' | 'light' | 'dark'
const DARK_FROM = 20; // 20:00
const DARK_TO = 7;    // 07:00

const computeEffective = (mode) => {
  if (mode === "light" || mode === "dark") return mode;
  const h = new Date().getHours();
  return (h >= DARK_FROM || h < DARK_TO) ? "dark" : "light";
};

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => localStorage.getItem(STORAGE_KEY) || "auto");
  const [effective, setEffective] = useState(() => computeEffective(localStorage.getItem(STORAGE_KEY) || "auto"));

  const apply = useCallback((m) => {
    const eff = computeEffective(m);
    setEffective(eff);
    const root = document.documentElement;
    if (eff === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
  }, []);

  useEffect(() => { apply(mode); }, [mode, apply]);

  // In modalità 'auto' ricontrolla ogni minuto per cambiare tema all'orario giusto.
  useEffect(() => {
    if (mode !== "auto") return;
    const id = setInterval(() => apply("auto"), 60000);
    return () => clearInterval(id);
  }, [mode, apply]);

  const setMode = useCallback((m) => {
    localStorage.setItem(STORAGE_KEY, m);
    setModeState(m);
  }, []);

  const value = useMemo(() => ({ mode, setMode, effective }), [mode, setMode, effective]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
